export const LegacyGlobal = (props: {
    className?: string;
    children: React.JSX.Element;
}) => {
    return (
        <div className={`legacy-global ${props.className ?? ""}`}>
            {props.children}
        </div>
    );
};
